import React, { useEffect, useState } from 'react';
import {
  Table, TableHead, TableBody, TableRow, TableCell,
  TextField, Button, Paper, TableContainer, Box,
  Typography, IconButton, useTheme, styled, Modal,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid2,
  Stack,
} from '@mui/material';
import { MdOutlineModeEdit } from "react-icons/md";
import { RxCross2 } from "react-icons/rx";
import { AiOutlineCheckCircle, AiOutlineCloseCircle } from "react-icons/ai";
import { useGetAllDprPMQuery, useEditDprPmListMutation } from 'store/slices/apis/keyDPRPMSlice';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import { usePermission } from 'hooks/usePermission';
import { DPR_PM_EDIT } from 'config';
import { openSnackbar, closeSnackbar } from "store/slices/snackbar";
import { useDispatch } from "store";
import PaginationComponent from 'components/ui-components/PaginationComponent';
import { ReactComponent as EditIcon } from "assets/PwC_Funct_Icons_Pencil_Outline_Black_RGB.svg"
import { ReactComponent as CrossIcon } from "assets/PwC_Funct_Icons_Close_Outline_Black_RGB.svg"

const StyledTableCell = styled(TableCell)({
  whiteSpace: "nowrap",
  border: '1px solid #ccc',
  textAlign: "center",
});

const StyledTableBody = styled(TableCell)({
  fontWeight: 400,
  fontSize: "14px",
  color: "#5052588A",
  padding: "10px 14px",
  backgroundColor: "#fff",
  textAlign: "center",
  whiteSpace: "nowrap",
  lineHeight: "20px",
  letterSpacing: "0.2px",
});

const textFieldStyles = {
  minWidth: 150,
  "& .MuiInput-underline:before": {
    borderBottom: "1px solid #ccc",
  },
  "& .MuiInput-underline:hover:before": {
    borderBottom: "2px solid #1976d2",
  },
  "& .MuiInput-underline:after": {
    borderBottom: "2px solid #1976d2",
  },
  input: {
    color: "#333",
    fontSize: "14px",
  },
};

const DPRPMList = () => {
  const editAccess = usePermission(DPR_PM_EDIT)
  const [editIndex, setEditIndex] = useState([]);
  const theme = useTheme();
  const dispatch = useDispatch();
  const [search, setSearch] = useState('');
  const { projectId } = useParams();
  const [tableData, setTableData] = useState([]);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [originalData, setOriginalData] = useState({});
  const [pageNumber, setPageNumber] = useState(1)
  const rowsPerPage = 10




  const [editKeyDprPm] = useEditDprPmListMutation();
  const { data } = useGetAllDprPMQuery({ projectId });



  const allPm = data?.data || [];



  const startIndex = (pageNumber - 1) * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;


  useEffect(() => {
    if (allPm.length >= 0) {
      setTableData(allPm.map(item => ({ ...item })));
    }
  }, [allPm]);

  const handleChange = (index, field, value) => {
    const updatedData = [...tableData];
    updatedData[index][field] = value;
    setTableData(updatedData);
  };


  const handleToggleEditClick = (index) => {
    if (!editIndex.includes(index)) {

      setOriginalData(prev => ({
        ...prev,
        [index]: { ...tableData[index] }
      }));
      setEditIndex(prev => [...prev, index]);
    } else {

      const updatedData = [...tableData];
      if (originalData[index]) {
        updatedData[index] = { ...originalData[index] };
      }
      setTableData(updatedData);
      setEditIndex(prev => prev.filter(i => i !== index));


      setOriginalData(prev => {
        const newData = { ...prev };
        delete newData[index];
        return newData;
      });
    }
  };


  const handleSearchChange = (e) => setSearch(e.target.value);

  const isRowEditable = (index) => editIndex.includes(index);

  const filteredData = tableData.filter(row =>
    (row.pm || "").toLowerCase().includes(search.toLowerCase())
  );

  const paginatedData = filteredData.slice(startIndex, endIndex);
  const totalPages = Math.ceil(filteredData.length / rowsPerPage);

  const openNotification = (message, type = 'success') => {
    dispatch(openSnackbar({
      open: true,
      message,
      variant: 'alert',
      alert: {
        color: type,
      },
      close: false,
    }));

    setTimeout(() => dispatch(closeSnackbar()), 3000);
  };

  const handleSubmitConfirm = async () => {
    try {
      const payload = tableData.filter((_, index) => editIndex.includes(index));
      const response = await editKeyDprPm(payload).unwrap();

      if (response) {
        const updatedData = tableData.map((row, index) => {
          if (editIndex.includes(index)) {
            const updatedRow = payload.find(p => p.id === row.id);
            return { ...row, ...updatedRow };
          }
          return row;
        });



        setTableData(updatedData);
        openNotification(response?.message, 'success')
      }

      setEditIndex([]);
      setConfirmationModal(false);
    } catch (error) {
      console.log("error", error)
      openNotification(error?.data?.message || "Something went wrong", "error");
      setConfirmationModal(false);
    }
  };

  return (
    <>
      <Grid2 container spacing={2} sx={{ mt: "20px" }}>
        {/* <Typography sx={{ fontWeight: 700, fontSize: "20px" }}>
          P&M List
        </Typography> */}
        <Grid2 size={12}>
          <Box
            sx={{
              display: "flex",
              alignItems: { xs: 'start', sm: 'center' },
              justifyContent: "space-between",
              flexDirection: { xs: 'column', sm: 'row' }
            }}
          >
            <Stack
              direction={{ xs: 'column', sm: 'row' }}
              spacing={2}
              sx={{
                // flexGrow: 2,
                alignItems: { xs: "stretch", sm: "center" }, // Full width on mobile
                width: { xs: '100%', sm: 'auto' }, // Stack takes full width
                "& .MuiStack-root": {
                  paddingTop: "15px",
                },
              }}
            >
              <TextField
                size='small'
                value={search}
                placeholder='Enter Equipment Name To Search'
                onChange={handleSearchChange}
                sx={{ width: { xs: '100%', sm: "400px" } }}
              />
            </Stack>
            {editAccess &&
              <Button
                variant="contained"
                onClick={() => setConfirmationModal(true)}
                sx={{
                  backgroundColor: `${theme?.customSettings?.themeColor}`,
                  color: "#FFF",
                  padding: "5px 20px",
                  fontWeight: "500",
                  textTransform: "none",
                  fontSize: "16px",
                  marginTop: "10px",
                  // marginLeft: '20px',
                  border: `1px solid ${theme?.customSettings?.themeColor}`,
                  '&.Mui-disabled': {
                    border: 'none'
                  }
                }}
              >
                Submit
              </Button>
            }

          </Box>
        </Grid2>
        {/* <Box sx={{ display: "flex", justifyContent: "space-between", mt: "20px" }}>
          <TextField
            size='small'
            value={search}
            placeholder='Enter Equipment Name To Search'
            onChange={handleSearchChange}
            sx={{ width: "400px" }}
          />
          {editAccess &&
            <Button
              sx={{
                border: '1px solid #25252517',
                p: "6px",
                backgroundColor: theme?.customSettings?.themeColor || '#1976d2',
                color: "#fff"
              }}
              onClick={() => setConfirmationModal(true)}
            >
              Submit
            </Button>
          }
        </Box> */}
        <Grid2 size={12} sx={{ mt: 2 }}>
          <Paper elevation={2}>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <StyledTableCell>Equipment name</StyledTableCell>
                    <StyledTableCell>Equipment category</StyledTableCell>
                    <StyledTableCell>Reporting Date</StyledTableCell>
                    <StyledTableCell>Tag</StyledTableCell>
                    <StyledTableCell>Available hours</StyledTableCell>
                    <StyledTableCell>Operating hours</StyledTableCell>
                    <StyledTableCell sx={{ whiteSpace: "normal", width: "150px" }}>No. of Breakdown</StyledTableCell>
                    {editAccess &&
                      <StyledTableCell>Edit</StyledTableCell>
                    }
                  </TableRow>
                </TableHead>

                <TableBody>
                  {paginatedData.length === 0 ? (
                    <TableRow>
                      <StyledTableBody colSpan={9}>No data available</StyledTableBody>
                    </TableRow>
                  ) : (
                    paginatedData.map((row, index) => (
                      <TableRow key={index}>
                        <StyledTableBody>{row.pm}</StyledTableBody>
                        <StyledTableBody>{row.category}</StyledTableBody>
                        <StyledTableBody>
                          {isRowEditable(index) ? (
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DatePicker
                                label="Enter Date"
                                format="DD-MM-YYYY"
                                value={row?.reportingDate ? dayjs(row.reportingDate) : dayjs()}
                                onChange={(newValue) =>
                                  handleChange(index, 'reportingDate', newValue ? newValue.toISOString() : '')
                                }
                                slotProps={{
                                  textField: {
                                    size: 'small',
                                    variant: 'standard',
                                    sx: textFieldStyles
                                  }
                                }}
                              />
                            </LocalizationProvider>
                          ) : (
                            row?.reportingDate && row?.reportingDate.trim() !== ""
                              ? dayjs(row.reportingDate).format("DD-MM-YYYY")
                              : dayjs().format('DD-MM-YYYY')
                          )}
                        </StyledTableBody>
                        <StyledTableBody>
                          {isRowEditable(index) ? (
                            <TextField
                              size="small"
                              variant="standard"
                              value={row?.tag || ''}
                              onChange={(e) => handleChange(index, 'tag', e.target.value)}
                              sx={textFieldStyles}
                            />
                          ) : row.tag}
                        </StyledTableBody>
                        <StyledTableBody>
                          {isRowEditable(index) ? (
                            <TextField
                              size="small"
                              variant="standard"
                              value={row?.availableHours || ''}
                              onChange={(e) => handleChange(index, 'availableHours', e.target.value)}
                              sx={textFieldStyles}
                            />
                          ) : row.availableHours}
                        </StyledTableBody>
                        <StyledTableBody>
                          {isRowEditable(index) ? (
                            <TextField
                              size="small"
                              variant="standard"
                              value={row?.operatingHours || ''}
                              onChange={(e) => handleChange(index, 'operatingHours', e.target.value)}
                              sx={textFieldStyles}
                            />
                          ) : row.operatingHours}
                        </StyledTableBody>
                        <StyledTableBody>
                          {isRowEditable(index) ? (
                            <TextField
                              size="small"
                              variant="standard"
                              value={row?.breakdownHours || ''}
                              onChange={(e) => handleChange(index, 'breakdownHours', e.target.value)}
                              sx={textFieldStyles}
                            />
                          ) : (
                            row.breakdownHours
                          )}
                        </StyledTableBody>
                        {editAccess &&
                          <StyledTableBody>
                            {isRowEditable(index) ? (
                              <IconButton onClick={() => handleToggleEditClick(index)} title="Cancel">
                                {/* <RxCross2 /> */}
                                <CrossIcon style={{ fontSize: "25px", width: "25px", height: "25px", fill: "#808080" }} />
                              </IconButton>
                            ) : (
                              <IconButton onClick={() => handleToggleEditClick(index)} title="Edit">
                                {/* <MdOutlineModeEdit /> */}
                                <EditIcon style={{ width: "25px", height: "25px", fill: "#808080" }} />
                              </IconButton>
                            )}
                          </StyledTableBody>
                        }
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1, pr: 2 }}>
            <PaginationComponent
              pageNumber={pageNumber}
              totalPages={totalPages || 1}
              onPageChange={setPageNumber}
            />
          </Box>
        </Grid2>



      </Grid2 >

      {/* Confirmation Modal */}
      < Dialog open={confirmationModal} onClose={() => setConfirmationModal(false)}>
        <DialogTitle
          sx={{
            color: "#252525",
            fontSize: "20px",
            lineHeight: "24px",
            fontWeight: 500,
          }}
        >
          Accept Changes
        </DialogTitle>
        <DialogContent>
          <Typography
            sx={{
              color: "#474747",
              fontSize: "16px",
              lineHeight: "24px",
              fontWeight: 400,
            }}
          >
            Are you sure you want to accept the changes? You can re edit
            this later.
          </Typography>
        </DialogContent>
        <DialogActions
          sx={{
            marginBottom: "20px",
          }}
        >
          <Button
            onClick={() => setConfirmationModal(false)}
            variant="outlined"
            sx={{
              color: theme?.customSettings?.themeColor,
              fontSize: "16px",
              fontWeight: "500",
              textTransform: "none",
              border: `1px solid ${theme?.customSettings?.themeColor}`,
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSubmitConfirm}
            variant="contained"
            sx={{
              backgroundColor: theme?.customSettings?.themeColor,
              color: "#fff",
              fontSize: "16px",
              fontWeight: "500",
              textTransform: "none",
              marginRight: "20px",
            }}
          >
            Accept Changes
          </Button>
        </DialogActions>
      </Dialog >

    </>
  );
};

export default DPRPMList;